/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeepaidby3Inputs */

const en_ticketsfeepaidby3 = /** @type {(inputs: Ticketsfeepaidby3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who pays the ticket fee?`)
};

const de_ticketsfeepaidby3 = /** @type {(inputs: Ticketsfeepaidby3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer zahlt die Ticketgebühr?`)
};

/**
* | output |
* | --- |
* | "Who pays the ticket fee?" |
*
* @param {Ticketsfeepaidby3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeepaidby3 = /** @type {((inputs?: Ticketsfeepaidby3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeepaidby3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeepaidby3(inputs)
	return de_ticketsfeepaidby3(inputs)
});
export { ticketsfeepaidby3 as "ticketsFeePaidBy" }